import { useState } from 'react';
import { TabContent, TabPane } from 'reactstrap';
import PropTypes from 'prop-types';
import DatosPersonales from './DatosPersonales';
import Loader from '../../layouts/loader/Loader';
import DatosTutores from './DatosTutores';
import Documentos from './Documentos';
import Sepa from './Sepa';
import DatosEscolares from './DatosEscolares';
import Contabilidad from './Contabilidad';
import Seguimiento from './Seguimiento';
import Requerimientos from './Requerimientos';

const PestañasDatos = ({
  setRecibosPendientes,
  prevActiveTab,
  activeTab,
  dataApi,
  missingDataFunction,
  missingDataFunctionT,
  missingDataFunctionE,
}) => {
  const [menorEdad, setMenorEdad] = useState(false);

  return (
    <>
      {dataApi === null ? (
        <Loader />
      ) : dataApi.datos === null ? (
        <p className="mt-2 text-danger">
          <strong>Este alumno no dispone de datos.</strong>
        </p>
      ) : (
        <TabContent style={{ padding: '24px 24px 0 24px' }} activeTab={activeTab}>
          <TabPane tabId="1">
            <DatosPersonales
              prevActiveTab={prevActiveTab}
              datosPersonales={dataApi.datos.personales}
              missingDataFunction={missingDataFunction}
              menorEdad={menorEdad}
              setMenorEdad={setMenorEdad}
            />
          </TabPane>

          <TabPane tabId="2">
            <DatosEscolares
              prevActiveTab={prevActiveTab}
              datosEscolares={dataApi.datos.escolares}
              datosPersonales={dataApi.datos.personales}
              missingDataFunction={missingDataFunctionE}
              userId={dataApi.id}
            />
          </TabPane>

          <TabPane tabId="3">
            <DatosTutores
              prevActiveTab={prevActiveTab}
              datosTutor={dataApi.datos.tutores}
              missingDataFunction={missingDataFunctionT}
              userId={dataApi.id}
              menorEdad={menorEdad}
            />
          </TabPane>

          <TabPane tabId="4">
            <Documentos datosDocumento={dataApi.datos.personales.driveId} />
          </TabPane>

          <TabPane tabId="5">
            <Sepa prevActiveTab={prevActiveTab} />
          </TabPane>

          <TabPane tabId="6">
            <Contabilidad setRecibosPendientes={setRecibosPendientes} />
          </TabPane>

          <TabPane tabId="7">
            <Seguimiento />
          </TabPane>

          <TabPane tabId="8">
            <Requerimientos />
          </TabPane>
        </TabContent>
      )}
    </>
  );
};

PestañasDatos.propTypes = {
  setRecibosPendientes: PropTypes.func,
  prevActiveTab: PropTypes.string,
  activeTab: PropTypes.string,
  dataApi: PropTypes.object,
  missingDataFunction: PropTypes.func,
  missingDataFunctionT: PropTypes.func,
  missingDataFunctionE: PropTypes.func,
};

export default PestañasDatos;
